import { action } from '@ember/object';
import Component from '@glimmer/component';
import type { PowerSelectAfterOptionsComponentSignature } from 'ember-power-select/components/power-select/after-options';

import type {
  Group,
  Option,
} from '../../../../types/components/prism/combo-select-input.ts';
import type { IconName } from '../../../../types/components/prism/icon.ts';
import PrismButton from '../../button.gts';

type ButtonType =
  | 'brand'
  | 'critical'
  | 'critical-secondary'
  | 'ghost'
  | 'intelligence'
  | 'intelligence-secondary'
  | 'primary'
  | 'secondary'
  | 'success'
  | 'unstyled'
  | 'warning';

interface PrismComboSelectInputUnsafeAdditionalActionArgs {
  buttonType?: ButtonType;
  dataTestId?: string;
  iconBefore?: IconName;
  isDisabled?: boolean;
  label: string;
  onClick: () => unknown;
}

interface PrismComboSelectInputUnsafeAdditionalActionSignature {
  Args: PowerSelectAfterOptionsComponentSignature<
    Option,
    Group<Option>
  >['Args'] &
    PrismComboSelectInputUnsafeAdditionalActionArgs;
}

export default class PrismComboSelectInputUnsafeAdditionalAction extends Component<PrismComboSelectInputUnsafeAdditionalActionSignature> {
  @action
  handleClick(): void {
    this.args.onClick();
    this.args.select.actions.close();
  }

  <template>
    <div class="dropdown__unsafe-additional-action">
      <PrismButton
        @buttonType={{if @buttonType @buttonType "secondary"}}
        @iconBefore={{@iconBefore}}
        @isDisabled={{@isDisabled}}
        @label={{@label}}
        @onClick={{this.handleClick}}
        data-test-id={{@dataTestId}}
      />
    </div>
  </template>
}
